module.exports = __webpack_public_path__ + "static/media/protect_it.ab4e9bf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/protect_it.jpg
// module id = 1326
// module chunks = 0